import {
  CHANGE_MEDPASS_LIST,
  CHANGE_MEDPASS_POPUP_VISIBILITY,
  CHANGE_SUB_MEDPASS_POPUP_VISIBILITY,
  CHANGE_SUBSCRIPTION_POPUP_VISIBILITY,
} from '../../actions/types';

const initialState = {
  medPassList: {
    // Combo pass list
    '1': [],
    // Video pass list
    '2': [],
    // Test pass list
    '3': [],
  },
  showSubscriptionPopup: false,
  showMedPassPopup: false,
  showSuccessfulMedPassPurchasePopup: false,
  subscriptionText: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_MEDPASS_LIST:
      return {
        ...state,
        medPassList: action.payload,
      };
    case CHANGE_SUBSCRIPTION_POPUP_VISIBILITY:
      return {
        ...state,
        showSubscriptionPopup: action.payload.popup,
        subscriptionText: action.payload.text,
      };
    case CHANGE_MEDPASS_POPUP_VISIBILITY:
      return {
        ...state,
        showMedPassPopup: action.payload,
      };
    case CHANGE_SUB_MEDPASS_POPUP_VISIBILITY:
      return {
        ...state,
        showSuccessfulMedPassPurchasePopup: action.payload,
      };
    default:
      return state;
  }
}
